import storage from '../storage'

/** Determines whether or not to show the rescheduled modal
 * @param state - The store state
 * @return {boolean}
 */

export default function (state) {

  const {
    docs: { bookingDoc },
    config: { channelId, webcastId }
  } = state

  const { dateUpdated: docDateUpdated } = bookingDoc
  const item = storage.getItem('talks-rescheduled')

  if (!item) return true

  const { gig, dateUpdated } = item

  if (gig !== `${channelId}-${webcastId}`) return true

  return docDateUpdated.toISOString() !== dateUpdated

}
